import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca175e06"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Klik hier of sleep bestanden naar dit gebied om te uploaden.", -1))
const _hoisted_2 = { class: "ant-upload-hint" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Bestandsnaam", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Belangrijk", -1))

import { computed, ref, withDefaults } from 'vue'
import { FileAddOutlined, InfoCircleOutlined, UploadOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'

interface Props {
  fileCount: number
  multiple?: boolean
  allowedMimeTypes?: string[]
  maxFileSize?: number
  canRename?: boolean
  canMarkAsImportant?: boolean
  canMarkAsConcept?: boolean
  uploadBtn?: boolean
}

interface CustomFile {
  name:string
  extension:string
  file:File
  concept:boolean
  important:boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageUploader',
  props: {
    fileCount: null,
    multiple: { type: Boolean, default: false },
    allowedMimeTypes: { default: () => ['image/jpeg', 'image/png'] },
    maxFileSize: { default: 8 },
    canRename: { type: Boolean, default: false },
    canMarkAsImportant: { type: Boolean, default: false },
    canMarkAsConcept: { type: Boolean, default: false },
    uploadBtn: { type: Boolean }
  },
  emits: ['newFile', 'newCustomFile'],
  setup(__props: any, { emit }) {

const props = __props as { fileCount: number, multiple: boolean, allowedMimeTypes: string[], maxFileSize: number, canRename: boolean, canMarkAsImportant: boolean, canMarkAsConcept: boolean, uploadBtn?: boolean };





const mimeMap: Record<string, string[]> = {
  'svg+xml': ['svg'],
  jpeg: ['jpg', 'jpeg'],
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['xls', 'xlsx'],
  'vnd.openxmlformats-officedocument.wordprocessingml.document': ['doc', 'docx']
}

const allowedExtensions = computed(() =>
  props.allowedMimeTypes.flatMap(mimeType => {
    const subtype = mimeType.split('/').pop() ?? ''
    return mimeMap[subtype] ?? [subtype]
  })
)

const files = ref<CustomFile[]>([])
const showSettingsModal = ref(false)

function upload (file:File) : boolean {
  if (!props.allowedMimeTypes.includes(file.type)) {
    message.error('Je kan alleen ' + allowedExtensions.value.join(', ') + '-bestanden uploaden!', 8)
    return false
  }

  const uploadedFileSize = file.size / 1024 / 1024
  if (uploadedFileSize > props.maxFileSize) {
    message.error('Jouw bestand (' + uploadedFileSize.toFixed(2).replace('.', ',') + 'MB) is groter dan de maximale bestandsgrootte van ' + props.maxFileSize + 'MB!', 8)
    return false
  }

  if (props.canRename || props.canMarkAsConcept || props.canMarkAsImportant) {
    files.value.push({
      name: file.name.substring(0, file.name.lastIndexOf('.')) || file.name, // filename without extension (.jpg)
      extension: file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length), // extension without '.' (jpg)
      file: file,
      concept: false,
      important: false
    })
    showSettingsModal.value = true
  } else {
    emit('newFile', file)
  }

  return false
}

function uploadCustomFile () : void {
  files.value.forEach((customFile:CustomFile) => {
    const file = new File([customFile.file], customFile.name + '.' + customFile.extension, { type: customFile.file.type })

    if (customFile.important || customFile.concept) {
      emit('newCustomFile', { file: file, important: customFile.important, concept: customFile.concept })
    } else {
      emit('newFile', file)
    }
  })
  closeSettingsModal()
}

function closeSettingsModal () : void {
  files.value = []
  showSettingsModal.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.uploadBtn)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.multiple || (!__props.multiple && __props.fileCount === 0))
            ? (_openBlock(), _createBlock(_component_a_upload, {
                key: 0,
                class: "woonon-uploader",
                multiple: __props.multiple,
                showUploadList: false,
                beforeUpload: upload
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadOutlined)),
                      _createTextVNode(" Bestand(en) toevoegen ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["multiple"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (__props.multiple || (!__props.multiple && __props.fileCount === 0))
            ? (_openBlock(), _createBlock(_component_a_upload_dragger, {
                key: 0,
                class: "woonon-uploader",
                multiple: __props.multiple,
                showUploadList: false,
                beforeUpload: upload
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FileAddOutlined), { class: "woonon-uploader-icon" }),
                  _hoisted_1,
                  _createElementVNode("p", _hoisted_2, [
                    _createTextVNode("Toegestaan: " + _toDisplayString(_unref(allowedExtensions).join(', ')), 1),
                    _hoisted_3,
                    _createTextVNode("Maximaal: " + _toDisplayString(__props.maxFileSize) + "MB", 1)
                  ])
                ]),
                _: 1
              }, 8, ["multiple"]))
            : _createCommentVNode("", true),
          (__props.multiple && __props.fileCount)
            ? (_openBlock(), _createBlock(_component_a_divider, { key: 1 }))
            : _createCommentVNode("", true)
        ], 64)),
    _createVNode(_component_a_modal, {
      title: "Instellingen voor bestand(en).",
      width: "600px",
      visible: showSettingsModal.value,
      okText: "Uploaden",
      onOk: uploadCustomFile,
      onCancel: closeSettingsModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: [16,16],
          class: "no-mb"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: !__props.canMarkAsImportant && !__props.canMarkAsConcept ? 24 : (__props.canMarkAsImportant && __props.canMarkAsConcept ? 16 : 20)
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["span"]),
            (__props.canMarkAsImportant)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 0,
                  span: 4
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.canMarkAsConcept)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 1,
                  span: 4
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", null, [
                      _createTextVNode(" Concept "),
                      _createVNode(_component_a_tooltip, { placement: "right" }, {
                        title: _withCtx(() => [
                          _createTextVNode("Concept-bestanden zijn alleen zichtbaar in de adviseur en kunnen op een later moment gepubliceerd worden.")
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(InfoCircleOutlined), { style: { marginLeft: '8px' } })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
          return (_openBlock(), _createBlock(_component_a_row, {
            gutter: [16,16],
            key: index
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: !__props.canMarkAsImportant && !__props.canMarkAsConcept ? 24 : (__props.canMarkAsImportant && __props.canMarkAsConcept ? 16 : 20)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    style: { width: '90%' },
                    suffix: `.${file.extension}`,
                    disabled: !__props.canRename,
                    value: file.name,
                    "onUpdate:value": ($event: any) => ((file.name) = $event)
                  }, null, 8, ["suffix", "disabled", "value", "onUpdate:value"])
                ]),
                _: 2
              }, 1032, ["span"]),
              (__props.canMarkAsImportant)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 4
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_switch, {
                        checked: file.important,
                        disabled: file.concept,
                        onChange: ($event: any) => (file.important = !file.important)
                      }, null, 8, ["checked", "disabled", "onChange"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (__props.canMarkAsConcept)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 1,
                    span: 4
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_switch, {
                        checked: file.concept,
                        onChange: ($event: any) => {file.concept = !file.concept; file.concept && (file.important = false)}
                      }, null, 8, ["checked", "onChange"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})